module.exports = __webpack_public_path__ + "media/icon-default.3b313163f557bc5fb239762e1f6486af.svg";